import "./ScheduleRow.scss"
import { ChecklistScheduleDto, ScheduleType } from "../model/ChecklistDtos"
import { t } from "i18next"
import i18n from "../../../i18n"
import { IconButtonCalendar, IconButtonDelete, IconButtonEdit, Row } from "../../../core/components"

interface ScheduleRowProps {
    key: number
    schedule: ChecklistScheduleDto
    handleCalendarClicked?: () => void
    handleEditSchedule: (idChecklist?: number, idChecklistSchedule?: number) => void
    handleDeleteSchedule: (idChecklist?: number, idChecklistSchedule?: number) => void
}

export default function ScheduleRow(props: ScheduleRowProps) {
    const formatDate = (dateStr?: string) => {
        if (!dateStr) {
            return ''
        }
        const date = new Date(dateStr);
        return new Intl.DateTimeFormat(i18n.language, { year: 'numeric', month: 'short', day: 'numeric' }).format(date);
    };

    return <Row className="schedule-row p-02" alignItems="center">
        <div style={{ display: 'flex', flexGrow: 1, flexDirection: 'row', justifyContent: 'space-between' }}>
            <span>
                {formatDate(props.schedule.startDate)} {props.schedule.endDate ? `- ${formatDate(props.schedule.endDate)}` : ""}
            </span>
            <span className="pr-1">
                {props.schedule.type ? t(ScheduleType[props.schedule.type]) : ""}
            </span>
        </div>
        <Row.End className="pr-1">
            <div style={{ display: 'flex', gap: "0.5rem" }}>
                {props.handleCalendarClicked ? <IconButtonCalendar size="small" onClick={props.handleCalendarClicked} /> : null}
                <IconButtonEdit size="small" onClick={() => props.handleEditSchedule(props.schedule.idChecklist, props.schedule.idChecklistSchedule)} />
                <IconButtonDelete size="small" onClick={() => props.handleDeleteSchedule(props.schedule.idChecklist, props.schedule.idChecklistSchedule)} />
            </div>
        </Row.End>
    </Row>
}
